// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layer[data-v-4979356c]{background:red;bottom:auto;height:100%;left:100%;position:fixed;right:auto;top:auto;width:100%;z-index:1000}.layer-2[data-v-4979356c]{animation-delay:.2s;background:blue}.from-right-to-left[data-v-4979356c]{animation-duration:.9s;animation-name:example-4979356c}@keyframes example-4979356c{0%{left:100%}99%{left:-100%;opacity:1}to{opacity:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
